module.exports = __webpack_public_path__ + "static/r6-52ab9d7d141760fab6def3c8cc241e51.jpg";